/** Updated by ChatWindow while mounted; read by GlobalChatToasts to avoid duplicate popups. */

export const chatFocusState = {
  view: 'direct',
  /** Normalized phone when view === 'direct' */
  directPeer: '',
  /** Group _id when view === 'groups' */
  groupId: '',
}

export function resetChatFocusState() {
  chatFocusState.view = 'direct'
  chatFocusState.directPeer = ''
  chatFocusState.groupId = ''
}
